import { Reducer } from 'redux'
import { ILmsProfileModel, IBasicProfile } from 'models/lmsProfile.model'
import { ILmsProfileState } from '../states/lmsProfile.state'
import * as fromActions from '../actions/lms-profiles.action'

export const initialState: ILmsProfileState = {
  list: [],
  total: 0,
  perPage: 0,
  sort: [],
  profile: {} as ILmsProfileModel,
  loading: false,
  allProfilesList: [] as IBasicProfile[],
}

export const reducer: Reducer<ILmsProfileState> = (
  state: ILmsProfileState = initialState,
  { type, payload }
) => {
  switch (type) {
    case fromActions.LMS_PROFILES_LIST_GET:
      return {
        ...state,
        loading: true,
      }
    case fromActions.LMS_PROFILES_LIST_SUCCESS: {
      const { data: list, total, perPage, sort } = payload
      return {
        ...state,
        list,
        total,
        perPage,
        sort,
        loading: false,
      }
    }
    case fromActions.LMS_ALL_PROFILES_LIST:
      return {
        ...state,
        loading: true,
      }
    case fromActions.LMS_ALL_PROFILES_LIST_SUCCESS:
      return {
        ...state,
        allProfilesList: payload,
        loading: false,
      }
    default:
      return state
  }
}
